webClient.constant("FARE_STATUS", {
    NOT_REFERENCED: 0,
    NOT_INCLUDED: 1,
    PAID: 2,
    PAID_WITH_FEE: 3,
    FREE_OF_CHARGE: 4,
});

webClient.directive("ngBrandedFaresCard", [
    "templateService",
    "FARE_STATUS",
    function (templateService, FARE_STATUS) {

        function getLocalizedText(displayTexts) {
            const currentLanguageCode =
                window.site && window.site.culture
                    ? window.site.culture.substring(0, 2).toUpperCase()
                    : "FR";
            const localizedEntry = (displayTexts || []).filter(function (t) {
                return t.language === currentLanguageCode;
            })[0];
            return localizedEntry
                ? localizedEntry.text
                : (displayTexts || [])[0]
                  ? displayTexts[0].text
                  : "";
        }

        function fareStatusToCssClass(status) {
            if (status === FARE_STATUS.FREE_OF_CHARGE) return "__success";
            if (status === FARE_STATUS.PAID || status === FARE_STATUS.PAID_WITH_FEE)
                return "__coin";
            return "__error";
        }

        function toItems(items) {
            return (items || [])
                .map(function (item) {
                    if (!item) return null;
                    const text = getLocalizedText(item.displayTexts);
                    return text
                        ? { text: text, itemClass: fareStatusToCssClass(item.status) }
                        : null;
                })
                .filter(Boolean);
        }

        function mapFareConditionToSections(fareCondition) {
            if (!fareCondition) return [];

            return [
                {
                    titleKey: "airbooking.brandedfares.luggage",
                    items: Object.values(fareCondition.baggage || {}).flat(),
                },
                {
                    titleKey: "airbooking.brandedfares.flexibility",
                    items: fareCondition.flexibility || [],
                    hasAsterisk: (fareCondition.flexibility || []).some(function (item) {
                        return item && (item.status === FARE_STATUS.PAID || item.status === FARE_STATUS.PAID_WITH_FEE || item.status === FARE_STATUS.FREE_OF_CHARGE);
                    }),
                },
                {
                    titleKey: "airbooking.brandedfares.onboardservices",
                    items: Object.values(fareCondition.onboardServices || {}),
                },
                {
                    titleKey: "airbooking.brandedfares.specialaccess",
                    items: Object.values(fareCondition.priorityAccess || {}),
                },
            ]
                .map(function (section) {
                    return { titleKey: section.titleKey, items: toItems(section.items), hasAsterisk: section.hasAsterisk || false };
                })
                .filter(function (section) {
                    return section.items.length > 0;
                });
        }

        return {
            restrict: "EA",
            scope: {
                proposal: "=",
                mode: "@",
                radioIndex: "=?",
                selectedBrandKey: "=?",
            },
            link: function ($scope, $element) {
                templateService.compile($scope, $element, "tpl/_BrandedFaresCardTPL.html");
                $scope.$watch("proposal", function (proposal) {
                    $scope.sections = mapFareConditionToSections(proposal && proposal.localizedFareConditions);
                });
            },
        };
    },
]);
